import { makeEndpointFns } from '../fns';
import { InfoMaterial, InfoMaterialCreateModel, InfoMaterialUpdateModel } from '@whiz-cart/node-shared/models/infoMaterials/infoMaterial';
import z from 'zod';

const { GET, POST, DELETE } = makeEndpointFns('storeManager');

export const infoMaterials = {
    /** Lists all info materials */
    listAllInfoMaterials: GET('api/v1/infomaterials/list', InfoMaterial.array()),

    /** Lists all info materials that apply to this store */
    listInfoMaterialsForStore: GET('api/v1/infomaterials/list/{storeGuid}', InfoMaterial.array()),

    /** Uploads a file to blob storage & returns the path */
    uploadInfoMaterial: POST.text('api/v1/infomaterials/upload', {
        body: z.instanceof(FormData),
    }),

    /** Creates a new info material */
    createInfoMaterial: POST('api/v1/infomaterials/create', InfoMaterial, {
        body: InfoMaterialCreateModel,
    }),

    /** Updates an existing info material */
    updateInfoMaterial: POST('api/v1/infomaterials/update/{id}', InfoMaterial, {
        body: InfoMaterialUpdateModel,
    }),

    /** Deletes an existing info material */
    deleteInfoMaterial: DELETE.void('api/v1/infomaterials/{id}'),

    /** Updates the order of all info materials */
    reorderInfoMaterials: POST.void('api/v1/infomaterials/reorder', {
        body: z.record(z.string(), z.int()),
    }),
};
